import React, { useState, useEffect } from 'react'
import Controllers from '../../Api/Controllers';
import CustomersForm from './CustomersForm'
import ReactPlaceholder from 'react-placeholder/lib';
import { useParams } from 'react-router-dom';
import { PageHeader, SurfaceCard } from '../../Components/Ui'

const Customers = () => {
    const { idCustomers } = useParams()
    const [data, setData] = useState({})
    const [ready, setReady] = useState(false)

    useEffect(() => {
        if (idCustomers) {
            Controllers.customers.get_customers_id({
                p_id_customers: idCustomers
            }).then(res => {
                setData(res.data)
                setReady(true)
            })
        } else {
            setData({})
            setReady(true)
        }
    }, [idCustomers])

    return <>
        <PageHeader
            eyebrow="Super Papelera — Espacio de trabajo"
            title={idCustomers ? 'Editar Colaborador' : 'Registrar Colaborador'}
            subtitle={idCustomers
                ? 'Actualiza la información del colaborador seleccionado.'
                : 'Completa el formulario para registrar un nuevo colaborador.'}
        />
        <SurfaceCard>
            <ReactPlaceholder ready={ready} showLoadingAnimation rows={20}>
                <CustomersForm {...(data?.id_customers ? { data } : {})} />
            </ReactPlaceholder>
        </SurfaceCard>
    </>
}

export default Customers
